import Form from "../../components/organisms/Motor-Insurance/index";

const FormPage = (props) =>{
    return <Form sendGTM={props.sendGTM} />
};
export default FormPage;